import React from 'react';
import { InputGroup as BootstrapInputGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function InputGroup({ className='', type, icon, label,  placeholder, error, onBlur, value, onChange=() => {}, ...rest}){
    // Checkbox case is special in html, we can't use value or checked=false to add default value
    // We have to set checked prop if value = 1 and unset checked prop if value = 0
    if (type === "checkbox" && value === "1") {
        rest.checked = value
    }
    return (
        <BootstrapInputGroup className={`${className} wz-neo-input-group ${(error ? 'error' : '')}`}>
            {
                icon && <BootstrapInputGroup.Prepend>
                    <BootstrapInputGroup.Text> <FontAwesomeIcon icon={icon || null}/></BootstrapInputGroup.Text>
                </BootstrapInputGroup.Prepend>
            }
            <input
                className="form-control wz-neo-input-element"
                type={type}
                placeholder={placeholder}
                onBlur={onBlur}
                onChange={onChange}
                value={value}
                {...rest}
            />
        </BootstrapInputGroup>
    )
}
